import { Grouping } from '@yleisradio/areena-types';
import styles from './MenuGroup.module.scss';
import { MenuList } from './MenuList';
import { FC } from 'react';

const generateKey = (grouping: Grouping) =>
  grouping.controls.length > 0
    ? grouping.controls[0]?.title
    : grouping.groupings[0]?.controls[0]?.title;

type Props = {
  grouping: Grouping;
  toggleSubMenu(): void;
};

export const MenuGroup: FC<Props> = ({ grouping, toggleSubMenu }) => (
  <div className={styles.menuGroup} key={generateKey(grouping)}>
    <MenuList
      controls={grouping.controls}
      groupTag={grouping.tag}
      toggleSubMenu={toggleSubMenu}
    />
    {grouping.groupings
      ? grouping.groupings.map((subGrouping, index) => (
          <MenuGroup
            grouping={subGrouping}
            key={index}
            toggleSubMenu={toggleSubMenu}
          />
        ))
      : null}
  </div>
);
